<div class="burger-menu-container flex justify-center">
    <p-listbox [options]="tabs" optionLabel="name" class="list-box" />
</div>